export default __webpack_public_path__ + "static/media/banner2.d699820e.png";